import { useEffect, useRef } from 'react';

// Sondage périodique économe, commun aux écrans de supervision.
// - un seul minuteur, jamais deux cycles en parallèle ;
// - en pause tant que l'onglet est masqué, reprise et actualisation immédiates au retour ;
// - espacement progressif tant que la réponse ne change pas, retour au rythme de base
//   dès qu'elle change ; ralentissement plus marqué après une erreur.
// Le relevé est renvoyé par la fonction de chargement (empreinte comparable) ; si elle
// ne renvoie rien, le rythme de base est conservé.
export function useSondage(charger, base = 15000, max = 120000) {
  const ref = useRef(charger);
  ref.current = charger;
  useEffect(() => {
    let minuteur = null;
    let arrete = false;
    let enCours = false;
    let delai = base;
    let empreinte;
    const planifier = (ms) => {
      clearTimeout(minuteur);
      minuteur = setTimeout(cycle, ms);
    };
    const cycle = async () => {
      if (arrete || enCours || document.hidden) return;
      enCours = true;
      try {
        const releve = await ref.current();
        const suivante = releve === undefined ? undefined : JSON.stringify(releve);
        if (suivante !== undefined && suivante === empreinte) delai = Math.min(Math.round(delai * 1.5), max);
        else delai = base;
        empreinte = suivante;
      } catch {
        delai = Math.min(delai * 2, max);
      } finally {
        enCours = false;
        if (!arrete && !document.hidden) planifier(delai);
      }
    };
    const reprise = () => {
      if (document.hidden) {
        clearTimeout(minuteur);
        return;
      }
      delai = base;
      planifier(0);
    };
    document.addEventListener('visibilitychange', reprise);
    planifier(base);
    return () => {
      arrete = true;
      clearTimeout(minuteur);
      document.removeEventListener('visibilitychange', reprise);
    };
  }, [base, max]);
}
